import { format, isSameDay } from 'date-fns'

import { EMPTY_STRING } from '../../../../constants/common'
import {
  DATE_HOURS_FORMAT,
  DATE_SHORT_FORMAT,
} from '../../../../constants/date'

export function getTags(props) {
  const { time } = props

  if (time) {
    return format(props.startDate, DATE_HOURS_FORMAT)
  }

  const startDate = props.startDate
    ? format(props.startDate, DATE_SHORT_FORMAT)
    : EMPTY_STRING
  let endDate = props.endDate
    ? format(props.endDate, DATE_SHORT_FORMAT)
    : EMPTY_STRING

  const prefix = startDate ? EMPTY_STRING : '...'
  const suffix = endDate ? EMPTY_STRING : '...'

  let divider = EMPTY_STRING

  if (isSameDay(props.startDate, props.endDate)) {
    endDate = EMPTY_STRING
  } else {
    divider = ' - '
  }

  return [{ label: `${prefix}${startDate}${divider}${endDate}${suffix}` }]
}
